<template>
  <div class="page-wrapper">
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="size"
      background
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: 'Page',
  props: {
    total: Number,
    size: Number,
    currentPageHome: Number
  },
  data () {
    return {
      // currentPage: 1
    }
  },
  computed: {
    currentPage () {
      return this.currentPageHome
    }
  },
  methods: {
    handleSizeChange (val) {
      this.$emit('changesize', val)
    },
    handleCurrentChange (val) {
      this.$emit('changePage', val)
    }
  }
}
</script>

<style lang="stylus" scoped>
.page-wrapper
  text-align right
  margin-top 20px
</style>



// WEBPACK FOOTER //
// src/pages/authority/components/Page.vue